// Alphabetical ordering for the AI-matching pick-lists (industries, org types, interest tags,
// networking goals, …) with any "Other" bucket pinned to the end regardless of where it lands
// alphabetically. Kept as a helper so the participant form, the match filters and the sponsor
// forms all present the same order.

const OTHER_CODES = ['other', 'others'];

// Event interest tags are authored per event and carry no canonical code, so the label is the
// only signal there. Norwegian catalogues spell the same bucket "Annet" / "Andre". The \b keeps
// "Other (please specify)" matching while leaving a real label like "Otherwise" alone.
const OTHER_LABEL = /^(others?|annet|andre)\b/i;

export function isOtherEntry(entry) {
  const code = (entry?.code || '').trim().toLowerCase();
  if (code && OTHER_CODES.includes(code)) return true;
  return OTHER_LABEL.test((entry?.label || '').trim());
}

export function sortTaxonomyEntries(entries) {
  if (!Array.isArray(entries)) return [];

  // Copy first — these arrays come straight out of Vuex state and sort() mutates in place.
  return [...entries].sort((a, b) => {
    const aOther = isOtherEntry(a);
    const bOther = isOtherEntry(b);
    if (aOther !== bOther) return aOther ? 1 : -1;

    // numeric:true so labels carrying figures ("SME (50-249 employees)") order by value
    // rather than by digit string.
    return (a?.label || '').localeCompare(b?.label || '', undefined, {
      sensitivity: 'base',
      numeric: true
    });
  });
}
